export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-brands-400.ttf?1815e00441357e01619e5793e1caa78a";